import { Component, OnInit, effect, inject } from '@angular/core';
import { GameCanvasComponent } from './features/game-canvas/game-canvas.component';
import { CoachMarkComponent } from './features/onboarding/coach-mark.component';
import { FunctionPickerComponent } from './features/onboarding/function-picker.component';
import { MachineArgPickerComponent } from './features/onboarding/machine-arg-picker.component';
import { ObservableArgPickerComponent } from './features/onboarding/observable-arg-picker.component';
import { SubscriberDestroyControlComponent } from './features/onboarding/subscriber-destroy-control.component';
import { TutorialLogComponent } from './features/onboarding/tutorial-log.component';
import { FooterComponent } from './features/hud/footer.component';
import { StatusStripComponent } from './features/hud/status-strip.component';
import { SubscriptionErrorBannerComponent } from './features/hud/subscription-error-banner.component';
import { TopBarComponent } from './features/hud/top-bar.component';
import { ZoomControlsComponent } from './features/hud/zoom-controls.component';
import { RecipesModalComponent } from './features/recipes/recipes-modal.component';
import { RxSidebarComponent } from './features/rx-sidebar/rx-sidebar.component';
import { ToolbarComponent } from './features/toolbar/toolbar.component';
import { OnboardingService } from './core/services/onboarding.service';
import { SimClockService } from './core/services/sim-clock.service';
import { UiStateService } from './core/services/ui-state.service';

@Component({
  selector: 'app-root',
  imports: [
    CoachMarkComponent,
    FooterComponent,
    FunctionPickerComponent,
    GameCanvasComponent,
    MachineArgPickerComponent,
    ObservableArgPickerComponent,
    RecipesModalComponent,
    StatusStripComponent,
    RxSidebarComponent,
    SubscriberDestroyControlComponent,
    SubscriptionErrorBannerComponent,
    ToolbarComponent,
    TopBarComponent,
    TutorialLogComponent,
    ZoomControlsComponent,
  ],
  templateUrl: './app.html',
})
export class App implements OnInit {
  private readonly clock = inject(SimClockService);
  private readonly onboarding = inject(OnboardingService);
  protected readonly ui = inject(UiStateService);

  constructor() {
    effect(() => this.clock.paused.set(this.onboarding.shouldPauseSim()));
  }

  ngOnInit(): void {
    this.clock.start();
  }
}
